import React, { useState,useEffect,useCallback,useRef } from "react";
import { useParams,useLocation,Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getTemplateDetail, submitSingle, getSingleDetail, updateSingle, deleteSingle} from "../../../utils/fileEmbedApi";

const ContentTab = ({ isTemplateId,setTemplateId,updateFileEmbedTabData,fileEmbedTabData,setRefreshWidgetList }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null); 
    const dropdownRefs = useRef([]);
    const [apiProfileSociaMediaIcons, setApiProfileSociaMediaIcons] = useState([]);
    const [isSubmitSingle, setIsSubmitSingle] = useState(false); 
    const location = useLocation();
    const isEditPage = location.pathname.startsWith("/customer/edit/file-embed/");
    const { uuid } = useParams();
    const templateId = isEditPage && uuid ? uuid : isTemplateId || "";
    const [apiSingle, setApiSingle] = useState(null);
    const [singleId, setSingleId] = useState(null);

    //details
    const [widgetTitle, setWidgetTitle] = useState(fileEmbedTabData.widget_title);

    //Wrap fetchTemplateDetails in useCallback to prevent re-creation on every render
    const fetchTemplateDetails = useCallback(async () => {
        if (!templateId) return;

        setIsLoading(true);
        try {
            const templateResult = await getTemplateDetail(templateId);
            if (templateResult?.status === true && Array.isArray(templateResult?.data?.data_list)) {
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    setApiProfileSociaMediaIcons(templateResult.data.data_list);
                } else {
                    setApiProfileSociaMediaIcons([]);
                }
            } else {
                setApiProfileSociaMediaIcons([]);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [templateId]);

    // Fix useEffect by including fetchTemplateDetails
    useEffect(() => {
        fetchTemplateDetails();
    }, [fetchTemplateDetails]);

    // Toggle dropdown visibility
    const toggleDropdown = (index) => {
        setOpenDropdown((prev) => (prev === index ? null : index));
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openDropdown !== null &&
                dropdownRefs.current[openDropdown] &&
                !dropdownRefs.current[openDropdown].contains(event.target) &&
                !event.target.closest(".inner-dropdown-menu")
            ) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    //Submit Single Handler
    const handleSubmitSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);

            // Create FormData object
            const module_type = 'File_Embed';
            const formData = new FormData();
            formData.append("template_id", templateId);
            formData.append("file_name", e.target.file_name?.files[0] || '');
            formData.append("name", e.target.name.value || '');
            formData.append("image", e.target.image?.files[0] || '');
            formData.append("alt_text", e.target.alt_text?.value || '');
            formData.append("module_type", module_type);

            //Api Call
            const response = await submitSingle(formData,module_type);
            
            if (response.status === true) { 
                toast.success(response.message);
                
                //Call templat details
                await fetchTemplateDetails();
                setActiveSettingElementsTab("main");
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    };

    // Handle Edit Click 
    const handleEditSingle = (data) => {
        setOpenDropdown(null);
        setSingleId(data.id);
        setActiveSettingElementsTab("edit_single");
        fetchSingleDetails(data.id);
    };

    // Handle Delete Click
    const handleDeleteSingle = async (data) => {
        setOpenDropdown(null);

        try {
            // Prepare the payload
            const payload = {
                single_id: data.id,
            };

            // API Call
            const api_response = await deleteSingle(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Refresh testimonials
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    // Wrap fetchSingleDetails in useCallback to prevent re-creation on every render
    const fetchSingleDetails = useCallback(async (singleId) => {
        if (!singleId) return;

        setIsLoading(true); 
        try {
            const templateResult = await getSingleDetail(singleId); 
            if (templateResult?.status === true && templateResult?.data) {
                setApiSingle(templateResult.data);
            } else { 
                setApiSingle(null);
            }
        } catch (error) {
            //console.error("Error fetching:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Also include fetchTemplateDetails in this useEffect
    useEffect(() => {
        if (isEditPage && uuid && !apiSingle) {
            fetchSingleDetails(uuid);
        }
    }, [isEditPage, uuid, apiSingle, fetchSingleDetails]);

    //Update Single Handler
    const handleUpdateSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);
            // Create FormData object
            const module_type = 'File_Embed';
            const formData = new FormData();
            formData.append("id", singleId);
            formData.append("file_name", e.target.file_name?.files[0] || '');
            formData.append("name", e.target.name?.value || '');
            formData.append("image", e.target.image?.files[0] || '');
            formData.append("alt_text", e.target.alt_text?.value || '');

            //Api Call
            const response = await updateSingle(formData,module_type);

            if (response.status) {
                toast.success(response.message);

                //Refresh Logo Showcase
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);

                // Switch back to the main view
                setActiveSettingElementsTab("main");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    }; 

    //Handlers Heading Change
    const handleHeadingChange = (e) => {
        const value = e.target.value;
        setWidgetTitle(value);
        updateFileEmbedTabData("widget_title", value); 
    };

    //useEffect to load settings
    useEffect(() => {
        if (fileEmbedTabData) {
            setWidgetTitle(fileEmbedTabData.widget_title || "");
        }
    }, [fileEmbedTabData]);

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label>Widget Title</label>
                            <input name="widget_title" value={widgetTitle} onChange={handleHeadingChange} placeholder="Widget Title..." type="text" />
                        </div>
                    </div>
                    <div className="side-baar-box-header ">
                        <div className="testimonal-side-baar-list">
                            {isLoading ? (
                                <div className="inner-loader-container">
                                    <div className="inner-spinner"></div>
                                    <p>Loading, please wait...</p>
                                </div>
                            ) : apiProfileSociaMediaIcons?.length > 0 ? (
                                <ul className="">
                                    {apiProfileSociaMediaIcons.map((data, index) => (
                                        <li key={index} className="testimonial-item">
                                            <button type="button" className="testimonial-item-button" onClick={() => handleEditSingle(data)}>
                                                {data.image && (
                                                    <div className="list-image-testimonal">
                                                        <img src={data.image } alt={data.alt_text} width="50" height="50"/>
                                                    </div>
                                                 )}
                                                <div className="list-text-testimonal">  
                                                    <p>{data.name}</p>
                                                </div>
                                            </button>
                                            <div className="list-button-testimonal" ref={(el) => (dropdownRefs.current[index] = el)}>
                                                <button onClick={() => toggleDropdown(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3.864 8.333a1.363 1.363 0 1 1 0 2.726 1.363 1.363 0 0 1 0-2.726Zm6.136 0a1.363 1.363 0 1 1 .001 2.726A1.363 1.363 0 0 1 10 8.333Zm6.136 0a1.363 1.363 0 1 1 .001 2.726 1.363 1.363 0 0 1 0-2.726Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            {openDropdown === index && (
                                                <div className="inner-dropdown-menu">
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleEditSingle(data)}>Edit</button>
                                                    </div>
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleDeleteSingle(data)}> Delete</button>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="add-testimonal-button">
                            <button onClick={() => setActiveSettingElementsTab("add_single")}>+ Add File</button>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "add_single" && (
                <div className="inner-box-layout">
                    <form onSubmit={handleSubmitSingle}>
                        <span>
                            <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                            </button>
                            Upload File
                        </span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>File</label>
                                 <input type="file" name="file_name" accept="
                                    .pdf,
                                    .doc,
                                    .docx,
                                    .xls,
                                    .xlsx,
                                    .csv,
                                    .ppt,
                                    .pptx,
                                    application/pdf,
                                    application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                    application/vnd.ms-excel,
                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                    text/csv,
                                    application/vnd.ms-powerpoint,
                                    application/vnd.openxmlformats-officedocument.presentationml.presentation
                                " 
                                />
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>Name</label>
                                <input name="name" placeholder="Name..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Preview Image</label>
                                <input type="file" name="image" accept="image/*" />
                            </div>
                            <div className="box-header-row bubble-text">
                                    <label>Alt Text</label>
                                    <input name="alt_text" placeholder="Alt text..." type="text" />
                                </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="customize-button mb-2"> 
                                <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                    {isSubmitSingle ? "Submiting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}

            {activeSettingElementsTab === "edit_single" && (
                <div className="inner-box-layout">
                    {isLoading ? (
                        <div className="inner-loader-container">
                            <div className="inner-spinner"></div>
                            <p>Loading, please wait...</p>
                        </div>
                    ) : apiSingle ? (
                        <>
                        <form onSubmit={handleUpdateSingle}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Edit File
                            </span>

                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>File</label>
                                    <input type="file" name="file_name" accept="
                                        .pdf,
                                        .doc,
                                        .docx,
                                        .xls,
                                        .xlsx,
                                        .csv,
                                        .ppt,
                                        .pptx,
                                        application/pdf,
                                        application/msword,
                                        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                        application/vnd.ms-excel,
                                        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                        text/csv,
                                        application/vnd.ms-powerpoint,
                                        application/vnd.openxmlformats-officedocument.presentationml.presentation
                                    " 
                                    />
                                    {apiSingle.file_name && (
                                        <Link 
                                            to={apiSingle.file_name} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            >
                                            <img 
                                                src={`${process.env.PUBLIC_URL}/images/pdf-icion.png`} 
                                                alt="PDF File" 
                                                width="50" 
                                                height="50"
                                            />
                                        </Link>
                                    )}
                                </div>
                            </div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>Name</label>
                                    <input name="name" value={apiSingle.name || ""} onChange={(e) => setApiSingle({ ...apiSingle, name: e.target.value })} placeholder="Name..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Preview Image</label>
                                    <input type="file" name="image" accept="image/*" />
                                    {apiSingle.image && (
                                        <img src={apiSingle.image} alt={apiSingle.alt_text}  width="50" height="50" />
                                    )}
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Alt Text</label>
                                    <input name="alt_text" value={apiSingle.alt_text || ""} onChange={(e) => setApiSingle({ ...apiSingle, alt_text: e.target.value })} placeholder="Alt text..." type="text" />
                                </div>
                            </div>

                            <div className="side-baar-box-header">
                                <div className="customize-button mb-2"> 
                                    <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                        {isSubmitSingle ? "Updating..." : "Update"}
                                    </button>
                                 </div>
                            </div>
                        </form>
                        </>
                    ) : (
                        <p>No single details. Please try again.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ContentTab;